import React, { ReactNode, useEffect, useRef } from "react";

interface InfiniteScrollProps {
  hasMore: boolean;
  togglePage: () => void;
  loading: boolean;
  children: ReactNode;
}

const InfiniteScroll: React.FC<InfiniteScrollProps> = ({
  hasMore,
  togglePage,
  loading,
  children,
}) => {
  const observer = useRef<IntersectionObserver | null>(null);
  const bottomElement = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (loading) return; // Don't observe while loading

    const observerCallback = ([entry]: IntersectionObserverEntry[]) => {
      if (entry.isIntersecting && !loading && hasMore) {
        console.log("Loading more items...");
        togglePage();
      }
    };

    const scrollElement = bottomElement;

    if (scrollElement.current) {
      observer.current = new IntersectionObserver(observerCallback, {
        threshold: 0.5,
      });
      observer.current.observe(scrollElement.current);
    }

    return () => {
      if (observer.current && scrollElement.current) {
        observer.current.disconnect();
      }
    };

    // not sure observer need dependency ...
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, hasMore, togglePage]);

  return (
    <div>
      {children}
      {loading && <div>LOADING ...</div>}
      {/* TODO this create a wite bar at the bottom */}
      <div
        ref={bottomElement}
        style={{
          height: "100px",
          visibility: "hidden",
        }}
      >
        scroll
      </div>
    </div>
  );
};

export default InfiniteScroll;
